module.exports = __webpack_public_path__ + "static/img/eq6.96c0114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/eq6.png
// module id = BisZ
// module chunks = 0